import AppRouter from 'common/AppRouter';
import {
  FILTERS_PROVIDER_STORAGE_KEYS,
  InvestmentCarvingFiltersContext,
  ProjectProgressionFiltersContext,
  ResourceAllocationFiltersContext
} from '../../../../../../contexts';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { STORAGE_TYPES } from 'common/constants/constants';
import { useHistory } from 'react-router';
import useTabsBuilder from 'components/RouterTabs/useTabsBuilder';
import useResourceAllocationPermissions from 'views/root/views/home/views/projects/ResourceAllocationOverview/useResourceAllocationPermissions';
import useInvestmentCarvingPermissions from 'views/root/views/home/views/projects/InvestmentCarving/useInvestmentCarvingPermissions';
import useProjectProgressionPermissions from 'views/root/views/home/views/projects/Forecasting/ProjectProgression/useProjectProgressionPermissions';
import {
  DonutIcon,
  InvestmentStrategyIcon,
  ProgressionIcon
} from '@linearb/linui-common';
import useEventsTracker from '../../../../tracking/useEventsTracker';
import useSelectedFilterSet from '../../../../../../hooks/useSelectedFilterSet';

const storageAccessor = BrowserStorageAccessor()[STORAGE_TYPES.LOCAL];

const useNavigationMenuItems = Context => {
  const history = useHistory();
  const selectedFilterSet = useSelectedFilterSet(Context);
  const currPath = history.location.pathname;

  const eventsTracker = useEventsTracker({ Context });
  const menuBuilder = useTabsBuilder();

  const resourceAllocationPermissions = useResourceAllocationPermissions();
  const investmentCarvingPermissions = useInvestmentCarvingPermissions();
  const projectProgressionPermissions = useProjectProgressionPermissions();

  const onClickMenuItem = menuItem => {
    const { Context, path } = menuItem;

    const storageKey =
      Context?.storageKeys[
        FILTERS_PROVIDER_STORAGE_KEYS.SELECTED_FILTER_SET_ID
      ];
    storageAccessor.set(storageKey, selectedFilterSet?.id);
    eventsTracker.onFilterSetNavigation(selectedFilterSet, Context);

    history.push(path);
  };

  menuBuilder.initTabs([
    {
      Icon: DonutIcon,
      name: ResourceAllocationFiltersContext.moduleName,
      path: AppRouter.PROJECTS_RESOURCE_ALLOCATION_OVERVIEW.path,
      Context: ResourceAllocationFiltersContext,
      permissions: resourceAllocationPermissions,
      onClick() {
        onClickMenuItem(this);
      }
    },
    {
      Icon: InvestmentStrategyIcon,
      name: InvestmentCarvingFiltersContext.moduleName,
      path: AppRouter.PROJECTS_INVESTMENT_CARVING.path,
      Context: InvestmentCarvingFiltersContext,
      permissions: investmentCarvingPermissions,
      onClick() {
        onClickMenuItem(this);
      }
    },
    {
      Icon: ProgressionIcon,
      name: ProjectProgressionFiltersContext.moduleName,
      path: AppRouter.PROJECTS_FORECASTING_ROOT.path,
      Context: ProjectProgressionFiltersContext,
      permissions: projectProgressionPermissions,
      onClick() {
        onClickMenuItem(this);
      }
    }
  ]);

  const permittedMenuItems = menuBuilder
    .build()
    .filter(item => !currPath.includes(item.path))
    .map(menuItem => {
      menuItem.onClick = menuItem.onClick.bind(menuItem);
      return menuItem;
    });

  return permittedMenuItems;
};

export default useNavigationMenuItems;
